<template>
  <div class="main-div">
    <v-container fluid grid-list-md :style="{ maxWidth: '1271px' }">
      <v-layout row wrap>
        <v-flex xs12 md12 lg8>
          <v-card class="my-3 pa-3 bordered-card">
            <v-card-title :class="[isMobile ? 'justify-center' : '']">
              Friend referral
            </v-card-title>
            <v-card-text>
              <v-layout v-if="!isMobile" row wrap>
                <v-flex
                  :class="[windowWidth < 811 ? 'xs2 md3 lg3' : 'xs3 md3 lg3']"
                >
                  <v-img
                    :src="qr_code ? 'data:image/png;base64,' + qr_code : ''"
                    class="qr-image"
                  />
                </v-flex>
                <v-flex
                  :class="[
                    'pt-0',
                    'pl-0',
                    windowWidth < 811 ? 'xs10 md9 lg9 pl-3' : 'xs9 md9 lg9'
                  ]"
                >
                  <p class="scan-title">
                    Scan this QR-code with your<br />
                    camera to share with your friends
                  </p>
                  <p class="link-title">
                    If you are unable to scan the QR-code, please use the
                    following link
                  </p>
                  <div class="link-area">
                    <a
                      v-if="user"
                      :href="
                        `https://gsmg.io/register?referral=${user.ref_code_own}`
                      "
                      >https://gsmg.io/register?referral={{
                        user.ref_code_own
                      }}</a
                    >
                  </div>
                </v-flex>
                <v-flex xs12 md12 lg12>
                  <p class="description">
                    When someone successfully registers with this link, then
                    their trial period will be extended with an extra 2 weeks of
                    free trading time on top of the original 6.
                  </p>
                </v-flex>
              </v-layout>
              <v-layout v-else row wrap>
                <v-flex xs12 md12 lg12>
                  <div
                    style="display: inline-block; width: 160px; float: left;"
                  >
                    <v-img
                      :src="qr_code ? 'data:image/png;base64,' + qr_code : ''"
                      class="qr-image"
                    />
                  </div>
                  <div
                    style="display: inline-block; width: 140px; padding-left: 16px; padding-top: 48px;"
                  >
                    <p class="scan-title">
                      Scan this QR-code with your<br />
                      camera to share with your friends
                    </p>
                  </div>
                </v-flex>
                <v-flex xs12 md12 lg12 style="margin-top: 19px;">
                  <p class="link-title">
                    If you are unable to scan the QR-code, please use the
                    following link
                  </p>
                  <div class="link-area">
                    <a
                      v-if="user"
                      :href="
                        `https://gsmg.io/register?referral=${user.ref_code_own}`
                      "
                      >https://gsmg.io/register?referral={{
                        user.ref_code_own
                      }}</a
                    >
                  </div>
                </v-flex>
                <v-flex xs12 md12 lg12>
                  <p class="description">
                    When someone successfully registers with this link, then
                    their trial period will be extended with an extra 2 weeks of
                    free trading time on top of the original 6.
                  </p>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 md12 lg12 class="px-0">
                  <div class="referral-explanation-box">
                    <div class="left-icon">
                      <v-img
                        :src="
                          '/img/subscription_payments_icon_' +
                            themeMode +
                            '.svg'
                        "
                        width="20"
                        height="20"
                      />
                    </div>
                    <div class="right-description">
                      <p class="referral-explanation">
                        Additionally, for every future deposit that they may
                        make, you <strong>will receive 5%</strong> of that
                        deposit as a referrer bonus in fuel or the equivalent in
                        time (depending on your subscription).
                      </p>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <OverviewOfDeposits></OverviewOfDeposits>
    </v-container>
  </div>
</template>

<style scoped>
.referral-explanation {
  margin-bottom: 0px;
}
.qr-image {
  width: 159px;
  height: 159px;
}
.left-icon {
  display: inline-block;
  width: 5%;
  float: left;
}
.right-description {
  display: inline-block;
  width: 95%;
}
.theme--light.application .main-div {
  background-color: #f2f7ff !important;
}
>>> .theme--light.bordered-card {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 15px;
}
>>> .theme--light .v-card__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #103a84;
}
>>> .theme--light p {
  color: #103a84;
}
.theme--light p.scan-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #103a84;
  margin-bottom: 30px;
}
.theme--light p.link-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #7395d0;
  margin-bottom: 18px;
}
.theme--light .link-area {
  text-align: center;
  background: #f0f2f5;
  border-radius: 1px;
  padding: 14px 24px;
}
.theme--light .link-area a {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  text-decoration-line: underline;
  color: #468aff;
  word-wrap: break-word;
}
.theme--light p.description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #103a84;
  padding-top: 36px;
  margin-bottom: 0px;
}
.theme--light .referral-explanation-box {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 24px;
  margin-top: 32px;
}
.theme--light .referral-explanation {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #103a84;
}
/******************/
>>> .theme--dark.bordered-card {
  background: #212121;
  box-shadow: none;
  border-radius: 15px;
}
>>> .theme--dark .v-card__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
}
>>> .theme--dark p {
  color: #e9e9e9;
}
.theme--dark p.scan-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #e9e9e9;
  margin-bottom: 30px;
}
.theme--dark p.link-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: rgba(235, 235, 245, 0.6);
  margin-bottom: 18px;
}
.theme--dark .link-area {
  text-align: center;
  background: #303030;
  border-radius: 1px;
  padding: 14px 24px;
}
.theme--dark .link-area a {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  text-decoration-line: underline;
  color: #639bfb;
  word-wrap: break-word;
}
.theme--dark p.description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: rgba(235, 235, 245, 0.6);
  padding-top: 36px;
  margin-bottom: 0px;
}
.theme--dark .referral-explanation-box {
  border: 1px solid #303030;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 24px;
  margin-top: 32px;
}
.theme--dark .referral-explanation {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #e9e9e9;
}

@media (max-width: 810px) {
  .qr-image {
    width: 120px;
    height: 120px;
    margin-top: 18px;
  }
}

@media (max-width: 768px) {
  .qr-image {
    width: 159px;
    height: 159px;
  }
  .link-area {
    text-align: left !important;
  }
  .bordered-card {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .left-icon {
    width: 34px;
  }
  .right-description {
    display: inline-block;
    width: 85%;
  }

}
</style>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import OverviewOfDeposits from "../components/referral/OverviewOfDeposits";

export default {
  components: {
    OverviewOfDeposits
  },
  data: () => ({
    rewards: {
      extra_start_fuel_referee_gwei: 0,
      extra_start_fuel_referrer_gwei: 0,
      referrer_reward_on_deposit_pct: 0
    },
    qr_code: "",
    windowWidth: window.innerWidth
  }),
  computed: {
    ...mapGetters({
      user: "auth/user",
      darkmode: "settings/darkmode"
    }),
    themeMode: function() {
      return this.darkmode ? "dark" : "light";
    },
    isMobile: function() {
      return this.windowWidth < 769;
    }
  },
  mounted: function() {
    axios.get("/api/v1/referrals/rewards").then(res => {
      this.rewards = res.data;
    });

    axios.get("/api/v1/referrals/getreferralqr").then(res => {
      this.qr_code = res.data;
    });

    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/referral.vue